import React from 'react'
import PropTypes from 'prop-types'

class ProgressTitle extends React.Component {

  constructor () {
    super ()

    this.state = {
      text: ""
    }
  }

  render () {
    return (
      <div>
        <h3 className="dashbuild-title-text">
          { this.props.text}
        </h3>
      </div>
    )
  }
}

ProgressTitle.propTypes = {
  text: PropTypes.string
}

export default ProgressTitle;
